function getTriggerDefs(page) {
  const mobileBreakpoint = page.getBreakpointByName('mobile');
  const desktopBreakpoint = page.getBreakpointByName('desktop');

  return page.elements
    .filter(
      elm =>
        // Forms have a main.js file that triggers the lightbox upon submit, so they
        // don't need a script insertion
        (elm.type === 'lp-pom-button' || elm.type === 'lp-pom-image') &&
        elm.model.linksToLightbox()
    )
    .map(elm => {
      const sizes = {
        desktop: elm.model.safeGet('lightboxSize', desktopBreakpoint),
        mobile: elm.model.safeGet('lightboxSize', mobileBreakpoint),
      };

      let selector;
      if (elm.type === 'lp-pom-button') {
        selector = '#' + elm.id;
      } else if (elm.type === 'lp-pom-image') {
        selector = '#' + elm.id + ' a';
      }

      if (sizes.desktop && selector) {
        return { selector, sizes };
      }
    })
    .filter(Boolean);
}

export default function getLightboxInsertion(page) {
  // Builds insertion containing global variable with trigger element definitions.
  const triggerDefs = getTriggerDefs(page);

  if (triggerDefs.length > 0) {
    return {
      content: `<script>window.ub.page.lightboxTriggers = ${JSON.stringify(triggerDefs)};</script>`,
      placement: 'head',
    };
  }
}



// WEBPACK FOOTER //
// ./src/publish/lightbox-insertions.js